/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Review_Pro3Inputs */

const en_fc_home_review_pro3 = /** @type {(inputs: Fc_Home_Review_Pro3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frame-exact timebase and native codecs, including ProRes export.`)
};

/**
* | output |
* | --- |
* | "Frame-exact timebase and native codecs, including ProRes export." |
*
* @param {Fc_Home_Review_Pro3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_review_pro3 = /** @type {((inputs?: Fc_Home_Review_Pro3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Review_Pro3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_review_pro3(inputs)
});
export { fc_home_review_pro3 as "fc.home.review.pro3" }